export enum DashboardTabs {
  PERFORMANCE = "Performance",
  ACCOUNTS = "Accounts",
}
